import {
  OPERATIONS_FAILED,
  OPERATIONS_INVALID_REQUEST,
  OPERATIONS_SUCCESS,
  // FETCH_MORE_OPERATIONS,
  RESET_OPERATIONS,
  LOADING_OPERATION,
  OPERATIONS_NOT_FOUND,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  notFound: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_OPERATION:
      return {
        ...state,
        isLoading: true,
        failed: false,
        notFound: false,
        invalidRequest: false,
        success: false,
      };

    case OPERATIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        success: false,
        invalidRequest: false,
        failed: true,
        data: action.payload,
      };

    case OPERATIONS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        success: false,
        invalidRequest: true,
        failed: false,
        data: action.payload,
      };

    case OPERATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: state.data.concat(action.payload),
      };

    case OPERATIONS_NOT_FOUND:
      return {
        isLoading: false,
        failed: false,
        invalidRequest: false,
        success: false,
        notFound: true,
        data: !action.fromFilter && state.data.length ? state.data : [],
      };

    case RESET_OPERATIONS:
      return (state = initialState);

    default:
      return state;
  }
};
